import { GuestInboxSendRecipient } from '../../StayTimeline.types'

export const getRecipientLabel = ({ name, emails, phones }: GuestInboxSendRecipient) => {
  return name ?? emails[0] ?? phones[0]
}

export const getRecipientRole = ({ personId, isAdditionalGuest }: GuestInboxSendRecipient) => {
  if (personId == null) return 'Not a guest on the booking'

  return isAdditionalGuest ? 'Additional guest' : 'Main guest'
}
